<template>
    <div class="depositCard"><img src="@/assets/themeThree/deposit-blue-dark.png" alt="" width="100%"></div>
    <div class="bgCard"><img src="@/assets/themeThree/bg-blue-dark.png" alt="" width="100%"></div>
    <van-row class="footer" justify="space-between" style="padding-bottom: 5px;">

        <van-col span="4" class="footer_item">
            <div v-if="tabList[0].display" class="footer_item_container" @click="goToPath(tabList[0].redirectUrl, 0)">
                <img :src="tabList[0].default_url" alt="">
                <div :style="{ color: activeFooter == 0 ? '#fff' : '' }">{{ $t(tabList[0].title) }}</div>
                <div v-if="activeFooter == 0" class="activeLine"></div>
            </div>
        </van-col>
        <van-col span="4" class="footer_item">
            <div v-if="tabList[1].display" class="footer_item_container" @click="goToPath(tabList[1].redirectUrl, 1)">
                <img :src="tabList[1].default_url" alt="">
                <div :style="{ color: activeFooter == 1 ? '#fff' : '' }">{{ $t(tabList[1].title) }}</div>
                <div v-if="activeFooter == 1" class="activeLine"></div>
            </div>
        </van-col>
        <van-col span="4" class="footer_button_item">
            <div v-if="tabList[2].display" class="footer_item_container" @click="goToPath(tabList[2].redirectUrl, 2)">
                <img :src="tabList[2].default_url" alt="">
                <div :style="{ color: activeFooter == 2 ? '#ffffff' : '#94ff7f' }" style="padding-top: 4px;">{{
                    $t(tabList[2].title) }}</div>
            </div>
        </van-col>
        <van-col span="4" class="footer_item">
            <div v-if="tabList[3].display" class="footer_item_container" @click="goToPath(tabList[3].redirectUrl, 3)">
                <div v-if="promoCount > 0" class="redPoint">{{ promoCount }}</div>
                <img :src="tabList[3].default_url" alt="">
                <div :style="{ color: activeFooter == 3 ? '#fff' : '' }">{{ $t(tabList[3].title) }}</div>
                <div v-if="activeFooter == 3" class="activeLine"></div>
            </div>
        </van-col>
        <van-col span="4" class="footer_item">
            <div v-if="tabList[4].display" class="footer_item_container" @click="goToPath(tabList[4].redirectUrl, 4)">
                <img :src="tabList[4].default_url" alt="">
                <div :style="{ color: activeFooter == 4 ? '#fff' : '' }">{{ $t(tabList[4].title) }}</div>
                <div v-if="activeFooter == 4" class="activeLine"></div>
            </div>
        </van-col>
    </van-row>
    <RegisterLoginPopup ref="registerRef" />
</template>

<script setup lang="ts">
import RegisterLoginPopup from '@/view/loginRegister/registerLoginPopup.vue';
import { ref, onMounted, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

interface TabItem {
    display: boolean,
    title: string,
    default_url: string,
    redirectUrl: string
}
const router = useRouter();

const props = defineProps<{
    itemData: {
        tabs: TabItem[]
    },
    activeFooter?: number
}>()
const userStore = useUserStore()
const tabList = computed(() => props.itemData.tabs);
const activeFooter = ref(props.activeFooter || 0);
const promoCount = computed(() => userStore.totalMsgListCount);
const registerRef = ref();

const goToPath = (path: string, indexValue: number) => {
    activeFooter.value = indexValue
    router.push(path)
    localStorage.setItem('footerPopupOpen', String(activeFooter.value))
}

const setProfileActiveFooter = () => {
    activeFooter.value = 4
}
const handleHistoryOpenPopup = () => {
    const indexNo: any = localStorage.getItem('footerPopupOpen')
    if (indexNo) {
        goToPath(tabList.value[indexNo].redirectUrl, indexNo)
    } else {
        goToPath(tabList.value[0].redirectUrl, 0)
    }

}
watch(activeFooter, (val) => {
    userStore.setIsInHome(val)
})
onMounted(() => {
    handleHistoryOpenPopup()
})
defineExpose({
    setProfileActiveFooter
})
</script>
<style scoped>
.footer {
    bottom: 0;
    z-index: 2500;
    width: 100vw;
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 0;
}

.depositCard {
    bottom: 0px;
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.depositCard img {
    width: 55%;
    height: 85px;
}

.bgCard {
    bottom: 0px;
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.bgCard img {
    width: 100%;
    height: 70px;
}

.footer_item_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #566488;
}

.footer_item img {
    width: 40px;
    height: 40px;
    padding-top: 0px;
}

.footer_button_item {
    justify-content: center;
    text-align: center;
}

.footer_button_item img {
    margin-top: -15px;
    width: 55px;
}

.activeLine {
    width: 10px;
    height: 2px;
    background: #94ff7f;
    margin-top: 4px;
    border-radius: 30px;
}

.redPoint {
    position: absolute;
    border-radius: 30px;
    background: #FF0000;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 8.5px;
    padding: 3px;
    font-weight: bold;
    margin: 5px 0 0px 40px;
    width: 10px;
    height: 10px;
}

@media (min-width:450px) {
    .footer {
        width: 100%;
    }
}

@media (min-width: 1440px) {
    .footer {
        width: 30rem;
    }
}

@media (min-width: 1920px) {
    .footer {
        width: 35rem;
    }
}
</style>